@if (templateData) {
  <div class="process-indicator compact responsive has-labels">
    <span class="responsive-label"><span>{{'InProgress' | translate}}: </span>{{processIndicatorResponsiveDisplayData?.label}}</span>
    <div class="display">
      @for (data of templateData; track data; let i = $index) {
        <div class="step" [id]="data.htmlStepId">
          <span class="label" soho-tooltip title="{{data.label}}">{{data.label}}</span>
          <div class="lines">
            <div class="indicator {{data.completionStatusInfo.indicatorClass}}" [ngClass]="{'icon': data.completionStatusInfo.iconInfo.icon}" soho-tooltip content="{{data | lmProcessIndicatorTooltip}}">
              @if (data.completionStatusInfo.iconInfo.icon) {
                <svg soho-icon icon="{{data.completionStatusInfo.iconInfo.icon}}" class="{{data.completionStatusInfo.iconInfo.colorClass}}"></svg>
              }
            </div>
            <span class="separator" [ngClass]="{'darker': (data.status === 'C' || data.status === 'X')}"></span>
          </div>
          <div class="details">
            <ng-template *ngTemplateOutlet="Approvers; context:{data: data}"></ng-template>
            <ng-template *ngTemplateOutlet="TimeStamp; context:{data: data}"></ng-template>
          </div>
        </div>
      }
    </div>
    <!-- display this when phone size -->
    <div class="responsive-details details">
      <ng-template *ngTemplateOutlet="Approvers; context:{data: processIndicatorResponsiveDisplayData}"></ng-template>
      <ng-template *ngTemplateOutlet="TimeStamp; context:{data: processIndicatorResponsiveDisplayData}"></ng-template>
    </div>
  </div>
}

<!-- shared templates -->
<ng-template #Approvers let-data=data>
  @if (data?.status) {
    <span class="heading">{{data.displayStatus}}</span>
  }
  @for (item of data?.stepApproversDisplay; track item) {
    <ng-template *ngTemplateOutlet="ApproverItem; context:{item: item}"></ng-template>
  }
  @if (data?.stepApproversOverflowContextMenuItems) {
    <a class="lm-more-approvers-link hyperlink" soho-context-menu attachToBody="false" [autoFocus]="true" [trigger]="'click'">more</a>
    <ul soho-popupmenu [id]="data.htmlStepOverflowId" class="approver-overflow-menu">
      @for (overflowItem of data.stepApproversOverflowContextMenuItems; track overflowItem) {
        <li soho-popupmenu-item>
          <ng-template *ngTemplateOutlet="ApproverItem; context:{item: overflowItem}"></ng-template>
        </li>
      }
    </ul>
  }
</ng-template>

<ng-template #TimeStamp let-data=data>
  @if (data?.elapsedTime) {
    <span class="elapsed-time" soho-tooltip content="{{data.elapsedTimeToolTip}}">
      {{data.elapsedTime}}
    </span>
  }
</ng-template>

<ng-template #ApproverItem let-item=item>
  <div class="item">
    @if (item?.icon) {
      <svg class="{{item.colorClass}}" soho-icon [icon]="item.displayIcon"></svg>
    }
    @if (item?.email) {
      <a class="hyperlink" href="mailto:{{item.email}}"><span>{{item.approver}}</span></a>
    }
    @if (!item?.email) {
      <span>{{item.approver}}</span>
    }
    @if (item?.tag) {
      <span [ngClass]="{'tag': item.tag, 'secondary': item.displayTag.type === 'secondary'}">{{item.displayTag.value}}</span>
    }
  </div>
</ng-template>
